export default {
  props: {
    question: Object
  },
  computed: {
    items() {
      const results = this.getAllItems()
      const ids = this.question.issue.voteAnswer
      if (!ids.length) return results
      return results.filter(item => ids.includes(item.id))
    },
  },
  methods: {
    getAllItems() {
      const vote = this.question.vote
      const items = this.question.issue.items
      return items.map(item => {
        const voteNum = vote.oidCountMap[item.id]
        let percentage = Number((voteNum / vote.totalNum * 100).toFixed(0))
        const source = {
          voteNum,
          percentage,
        }
        return Object.assign(
          {},
          item,
          source
        )
      })
        .sort((a, b) => b.voteNum - a.voteNum)
        .map((item, index) => {
          return Object.assign({}, item, { num: index + 1 })
        })
    }
  }
}